/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  Overrides,
  BigNumberish,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  LiquidationHelper,
  LiquidationHelperInterface,
} from "../LiquidationHelper";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_repository",
        type: "address",
      },
      {
        internalType: "address",
        name: "_chainlinkPriceProvider",
        type: "address",
      },
      {
        internalType: "address",
        name: "_lens",
        type: "address",
      },
      {
        internalType: "address",
        name: "_exchangeProxy",
        type: "address",
      },
      {
        components: [
          {
            internalType: "address",
            name: "asset",
            type: "address",
          },
          {
            internalType: "contract IMagician",
            name: "magician",
            type: "address",
          },
        ],
        internalType: "struct LiquidationHelper.MagicianConfig[]",
        name: "_magicians",
        type: "tuple[]",
      },
      {
        components: [
          {
            internalType: "contract IPriceProvider",
            name: "provider",
            type: "address",
          },
          {
            internalType: "contract ISwapper",
            name: "swapper",
            type: "address",
          },
        ],
        internalType: "struct LiquidationHelper.SwapperConfig[]",
        name: "_swappers",
        type: "tuple[]",
      },
      {
        internalType: "uint256",
        name: "_baseCost",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "AddressZero",
    type: "error",
  },
  {
    inputs: [],
    name: "ApprovalFailed",
    type: "error",
  },
  {
    inputs: [],
    name: "FallbackPriceProviderNotSet",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidChainlinkProviders",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidMagicianConfig",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidScenario",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidSiloLens",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidSiloRepository",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidSwapperConfig",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidTowardsAssetConvertion",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "inTheRed",
        type: "uint256",
      },
    ],
    name: "LiquidationNotProfitable",
    type: "error",
  },
  {
    inputs: [],
    name: "MagicianNotFound",
    type: "error",
  },
  {
    inputs: [],
    name: "Max0xSwapsIs2",
    type: "error",
  },
  {
    inputs: [],
    name: "NotSilo",
    type: "error",
  },
  {
    inputs: [],
    name: "PriceProviderNotFound",
    type: "error",
  },
  {
    inputs: [],
    name: "RepayFailed",
    type: "error",
  },
  {
    inputs: [],
    name: "SwapAmountInFailed",
    type: "error",
  },
  {
    inputs: [],
    name: "SwapAmountOutFailed",
    type: "error",
  },
  {
    inputs: [],
    name: "SwapperNotFound",
    type: "error",
  },
  {
    inputs: [],
    name: "TargetNotExchangeProxy",
    type: "error",
  },
  {
    inputs: [],
    name: "UsersMustMatchSilos",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sellToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "buyToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "boughtAmount",
        type: "uint256",
      },
    ],
    name: "BoughtTokens",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "silo",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "earned",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "estimatedEarnings",
        type: "bool",
      },
    ],
    name: "LiquidationExecuted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "contract IMagician",
        name: "magician",
        type: "address",
      },
    ],
    name: "MagicianConfigured",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "contract IPriceProvider",
        name: "provider",
        type: "address",
      },
      {
        indexed: false,
        internalType: "contract ISwapper",
        name: "swapper",
        type: "address",
      },
    ],
    name: "SwapperConfigured",
    type: "event",
  },
  {
    inputs: [],
    name: "CHAINLINK_PRICE_PROVIDER",
    outputs: [
      {
        internalType: "contract ChainlinkV3PriceProvider",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "EXCHANGE_PROXY",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "LENS",
    outputs: [
      {
        internalType: "contract SiloLens",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PRICE_PROVIDERS_REPOSITORY",
    outputs: [
      {
        internalType: "contract IPriceProvidersRepository",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "QUOTE_TOKEN",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "SILO_REPOSITORY",
    outputs: [
      {
        internalType: "contract ISiloRepository",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_users",
        type: "address[]",
      },
      {
        internalType: "contract ISilo[]",
        name: "_silos",
        type: "address[]",
      },
    ],
    name: "checkDebt",
    outputs: [
      {
        internalType: "bool[]",
        name: "",
        type: "bool[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_users",
        type: "address[]",
      },
      {
        internalType: "contract ISilo[]",
        name: "_silos",
        type: "address[]",
      },
    ],
    name: "checkSolvency",
    outputs: [
      {
        internalType: "bool[]",
        name: "",
        type: "bool[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_gasStart",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_earnedEth",
        type: "uint256",
      },
    ],
    name: "ensureTxIsProfitable",
    outputs: [
      {
        internalType: "uint256",
        name: "txFee",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
      {
        internalType: "contract ISilo",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "enum ILiquidationHelper.LiquidationScenario",
        name: "_scenario",
        type: "uint8",
      },
      {
        components: [
          {
            internalType: "address",
            name: "sellToken",
            type: "address",
          },
          {
            internalType: "address",
            name: "allowanceTarget",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "swapCallData",
            type: "bytes",
          },
        ],
        internalType: "struct ZeroExSwap.SwapInput0x[]",
        name: "_swapsInputs0x",
        type: "tuple[]",
      },
    ],
    name: "executeLiquidation",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_sellToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "_spender",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "_swapCallData",
        type: "bytes",
      },
    ],
    name: "fillQuote",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "findPriceProvider",
    outputs: [
      {
        internalType: "contract IPriceProvider",
        name: "priceProvider",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "liquidationSupported",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "magicians",
    outputs: [
      {
        internalType: "contract IMagician",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "asset",
            type: "address",
          },
          {
            internalType: "contract IMagician",
            name: "magician",
            type: "address",
          },
        ],
        internalType: "struct LiquidationHelper.MagicianConfig[]",
        name: "_magicians",
        type: "tuple[]",
      },
    ],
    name: "setMagicians",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IPriceProvider",
            name: "provider",
            type: "address",
          },
          {
            internalType: "contract ISwapper",
            name: "swapper",
            type: "address",
          },
        ],
        internalType: "struct LiquidationHelper.SwapperConfig[]",
        name: "_swappers",
        type: "tuple[]",
      },
    ],
    name: "setSwappers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "_assets",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_receivedCollaterals",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "_shareAmountsToRepaid",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "_flashReceiverData",
        type: "bytes",
      },
    ],
    name: "siloLiquidationCallback",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IPriceProvider",
        name: "",
        type: "address",
      },
    ],
    name: "swappers",
    outputs: [
      {
        internalType: "contract ISwapper",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "0x6101606040523480156200001257600080fd5b5060405162003ef938038062003ef9833981016040819052620000359162000696565b83620000413362000219565b6001600160a01b0381166200006957604051639fabe1c160e01b815260040160405180910390fd5b6001600160a01b039081166080526200009590861663035054cd62000269602090811b6200125817901c565b620000b35760405163778e646d60e11b815260040160405180910390fd5b620000d7876001600160a01b031663e99ed41d6200026960201b620012581760201c565b620000f4576040516295241d60e21b815260040160405180910390fd5b6001600160a01b0380881660c0528516610100526200011382620002f3565b6200011e8362000415565b866001600160a01b0316635ddf2be36040518163ffffffff1660e01b8152600401602060405180830381865afa1580156200015d573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019062000183919062000805565b6001600160a01b0390811660e08190529087166101405260408051630217a4b760e41b8152905163217a4b70916004808201926020929091908290030181865afa158015620001d6573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190620001fc919062000805565b6001600160a01b03166101205260a052506200088f945050505050565b600080546001600160a01b038381166001600160a01b0319831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b60006001600160a01b03831615801590620002ec575082826040518163ffffffff1660e01b8152600401602060405180830381865afa158015620002b1573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190620002d7919062000825565b60e083901b6001600160e01b03199081169116145b9392505050565b60005b81518110156200041157600082828151811062000317576200031762000851565b602002602001015160000151905060008383815181106200033c576200033c62000851565b602002602001015160200151905060006001600160a01b0316826001600160a01b031614806200037357506001600160a01b038116155b156200039257604051635d7aa74360e11b815260040160405180910390fd5b6001600160a01b0382811660008181526001602090815260409182902080546001600160a01b031916948616948517905581519283528201929092527f388056c710663a451dfea6adfe8ff11b52af5529b0a3d1c69ba90f1fc3f2dc56910160405180910390a150508080620004089062000867565b915050620002f6565b5050565b60005b81518110156200041157600082828151811062000439576200043962000851565b602002602001015160000151905060008383815181106200045e576200045e62000851565b602002602001015160200151905060006001600160a01b0316826001600160a01b031614806200049557506001600160a01b038116155b15620004b45760405163acb22e5160e01b815260040160405180910390fd5b6001600160a01b0382811660008181526002602090815260409182902080546001600160a01b031916948616948517905581519283528201929092527f53db4a2342abba949712a6909b124e7452f4c84834894b2a75a377f5201ef610910160405180910390a1505080806200052a9062000867565b91505062000418565b6001600160a01b03811681146200054957600080fd5b50565b634e487b7160e01b600052604160045260246000fd5b604080519081016001600160401b03811182821017156200058757620005876200054c565b60405290565b604051601f8201601f191681016001600160401b0381118282101715620005b857620005b86200054c565b604052919050565b60006001600160401b03821115620005dc57620005dc6200054c565b5060051b60200190565b600082601f830112620005f857600080fd5b81516020620006116200060b83620005c0565b6200058d565b82815260069290921b840181019181810190868411156200063157600080fd5b8286015b848110156200068b5760408189031215620006505760008081fd5b6200065a62000562565b8151620006678162000533565b815281850151620006788162000533565b8186015283529183019160400162000635565b509695505050505050565b600080600080600080600060e0888a031215620006b257600080fd5b8751620006bf8162000533565b6020890151909750620006d28162000533565b6040890151909650620006e58162000533565b6060890151909550620006f88162000533565b60808901519094506001600160401b03808211156200071657600080fd5b818a0191508a601f8301126200072b57600080fd5b81516200073c6200060b82620005c0565b8082825260208201915060208360061b86010192508d8311156200075f57600080fd5b6020850194505b82851015620007c6576040858f0312156200078057600080fd5b6200078a62000562565b8551620007978162000533565b81526020860151620007a98162000533565b806020830152508083525060208201915060408501945062000766565b60a08d01519097509350505080821115620007e057600080fd5b50620007ef8a828b01620005e6565b92505060c0880151905092959891949750929550565b6000602082840312156200081857600080fd5b8151620002ec8162000533565b6000602082840312156200083857600080fd5b81516001600160e01b031981168114620002ec57600080fd5b634e487b7160e01b600052603260045260246000fd5b6000600182016200088857634e487b7160e01b600052601160045260246000fd5b5060010190565b60805160a05160c05160e0516101005161012051610140516135b4620009456000396000818161021f01528181610b990152610bef0152600081816102f0015281816106c70152818161171c0152818161192701528181611c41015281816121db01526124c50152600081816101a301526105a501526000818161027301528181610b01015261179b0152600081816103e60152610f8c01526000610dc00152600081816102a701526109b001526135b46000f3fe60806040526004361061012d5760003560e01c80638cad7fbe116100ab578063a7e8489d1161006f578063a7e8489d146103d4578063be52003914610408578063dde643031461043e578063e7b43da51461045e578063f2fde38b1461047e578063fa40a0041461049e57600080fd5b80638cad7fbe146103125780638cf16261146103485780638da5cb5b1461036857806394fa3add14610386578063a143e5f7146103a657600080fd5b80633e4504c8116100f25780633e4504c8146102415780636f0ad2ca146102615780636fca4f8f14610295578063715018a6146102c957806378892cea146102de57600080fd5b80624796c61461013957806303a69c9a1461015b57806318a4619a14610191578063338799b0146101dd57806339060ea41461020d57600080fd5b3661013457005b600080fd5b34801561014557600080fd5b5061015961015436600461294d565b6104be565b005b34801561016757600080fd5b5061017b6101763660046129d2565b610550565b6040516101889190612a3d565b60405180910390f35b34801561019d57600080fd5b506101c57f000000000000000000000000000000000000000000000000000000000000000081565b6040516001600160a01b039091168152602001610188565b3480156101e957600080fd5b506101fd6101f8366004612a98565b6106c3565b6040519015158152602001610188565b34801561021957600080fd5b506101c57f000000000000000000000000000000000000000000000000000000000000000081565b34801561024d57600080fd5b5061015961025c366004612acb565b6107d9565b34801561026d57600080fd5b506101c57f000000000000000000000000000000000000000000000000000000000000000081565b3480156102a157600080fd5b506101c57f000000000000000000000000000000000000000000000000000000000000000081565b3480156102d557600080fd5b50610159610900565b3480156102ea57600080fd5b506101c57f000000000000000000000000000000000000000000000000000000000000000081565b34801561031e57600080fd5b506101c561032d366004612a98565b6001602052600090815260409020546001600160a01b031681565b34801561035457600080fd5b50610159610363366004612c43565b610936565b34801561037457600080fd5b506000546001600160a01b03166101c5565b34801561039257600080fd5b506101c56103a1366004612a98565b610adf565b3480156103b257600080fd5b506103c66103c1366004612ca4565b610dbb565b604051908152602001610188565b3480156103e057600080fd5b506101c57f000000000000000000000000000000000000000000000000000000000000000081565b34801561041457600080fd5b506101c5610423366004612a98565b6002602052600090815260409020546001600160a01b031681565b34801561044a57600080fd5b5061017b6104593660046129d2565b610e16565b34801561046a57600080fd5b50610159610479366004612cc6565b610f77565b34801561048a57600080fd5b50610159610499366004612a98565b611138565b3480156104aa57600080fd5b506101596104b936600461294d565b6111d3565b6000546001600160a01b031633146104f15760405162461bcd60e51b81526004016104e890612dc8565b60405180910390fd5b61054c8282808060200260200160405190810160405280939291908181526020016000905b828210156105425761053360408302860136819003810190612dfd565b81526020019060010190610516565b50505050506112e0565b5050565b60606000846001600160401b0381111561056c5761056c612b44565b604051908082528060200260200182016040528015610595578160200160208202803683370190505b50905060005b858110156106b9577f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316638705c3598686848181106105e4576105e4612e3e565b90506020020160208101906105f99190612a98565b89898581811061060b5761060b612e3e565b90506020020160208101906106209190612a98565b6040516001600160e01b031960e085901b1681526001600160a01b03928316600482015291166024820152604401602060405180830381865afa15801561066b573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061068f9190612e54565b8282815181106106a1576106a1612e3e565b9115156020928302919091019091015260010161059b565b5095945050505050565b60007f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316826001600160a01b03160361070657506001919050565b6001600160a01b03828116600090815260026020526040902054161561072e57506001919050565b6040516394fa3add60e01b81526001600160a01b038316600482015230906394fa3add90602401602060405180830381865afa92505050801561078e575060408051601f3d908101601f1916820190925261078b91810190612e76565b60015b6107c8573d8080156107bc576040519150601f19603f3d011682016040523d82523d6000602084013e6107c1565b606091505b50506107d1565b50600192915050565b506000919050565b60028111156107fb5760405163f554afbd60e01b815260040160405180910390fd5b60005a6040805160018082528183019092529192506000919060208083019080368337019050509050868160008151811061083857610838612e3e565b60200260200101906001600160a01b031690816001600160a01b031681525050856001600160a01b03166393a94ca3823385898989604051602001610881959493929190612ed2565b6040516020818303038152906040526040518363ffffffff1660e01b81526004016108ad929190613051565b6000604051808303816000875af11580156108cc573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526108f491908101906131af565b50505050505050505050565b6000546001600160a01b0316331461092a5760405162461bcd60e51b81526004016104e890612dc8565b61093460006113f2565b565b60405163095ea7b360e01b81526001600160a01b038381166004830152600019602483015284169063095ea7b3906044016020604051808303816000875af1158015610986573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906109aa9190612e54565b506000807f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316836040516109e6919061328d565b6000604051808303816000865af19150503d8060008114610a23576040519150601f19603f3d011682016040523d82523d6000602084013e610a28565b606091505b509150915081610a645760408051808201909152601081526f14d5d05417d0d0531317d1905253115160821b6020820152610a64908290611442565b60405163095ea7b360e01b81526001600160a01b0385811660048301526000602483015286169063095ea7b3906044016020604051808303816000875af1158015610ab3573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610ad79190612e54565b505050505050565b604051635d54e39560e01b81526001600160a01b0382811660048301526000917f000000000000000000000000000000000000000000000000000000000000000090911690635d54e39590602401602060405180830381865afa158015610b4a573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610b6e9190612e76565b90506001600160a01b038116610b9757604051637de7a71560e11b815260040160405180910390fd5b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316816001600160a01b031603610c885760405163db09c3fd60e01b81526001600160a01b0383811660048301527f0000000000000000000000000000000000000000000000000000000000000000169063db09c3fd90602401602060405180830381865afa158015610c36573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610c5a9190612e76565b90506001600160a01b038116610c835760405163dc3810cb60e01b815260040160405180910390fd5b919050565b806001600160a01b031663ca0a8f226040518163ffffffff1660e01b8152600401602060405180830381865afa925050508015610ce2575060408051601f3d908101601f19168201909252610cdf91810190612e54565b60015b610d1c573d808015610d10576040519150601f19603f3d011682016040523d82523d6000602084013e610d15565b606091505b5050919050565b8015610db55760405163db09c3fd60e01b81526001600160a01b03848116600483015283169063db09c3fd90602401602060405180830381865afa158015610d68573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610d8c9190612e76565b91506001600160a01b038216610db55760405163dc3810cb60e01b815260040160405180910390fd5b50919050565b6000807f00000000000000000000000000000000000000000000000000000000000000005a8503019050803a02915082821115610e0f5760405163e1c4c60560e01b815283830360048201526024016104e8565b5092915050565b6060838214610e385760405163fedad93960e01b815260040160405180910390fd5b6000846001600160401b03811115610e5257610e52612b44565b604051908082528060200260200182016040528015610e7b578160200160208202803683370190505b50905060005b858110156106b957848482818110610e9b57610e9b612e3e565b9050602002016020810190610eb09190612a98565b6001600160a01b03166338b51ce1888884818110610ed057610ed0612e3e565b9050602002016020810190610ee59190612a98565b6040516001600160e01b031960e084901b1681526001600160a01b039091166004820152602401602060405180830381865afa158015610f29573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610f4d9190612e54565b828281518110610f5f57610f5f612e3e565b91151560209283029190910190910152600101610e81565b60405163025e1b9b60e31b81523360048201527f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316906312f0dcd890602401602060405180830381865afa158015610fdb573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610fff9190612e54565b61101c5760405163a812ea3160e01b815260040160405180910390fd5b600080808061102d858701876132a9565b93509350935093508051600014611047576110478161146b565b6000611059838f8f8f8f8f8f8f6114e1565b9050600061107784600781111561107257611072612e93565b6115c5565b9050600061109585600781111561109057611090612e93565b6115fe565b905081156110b2576110ab8f8f8d8d8b86611659565b92506110bc565b6110bc8784611911565b8f6001600160a01b0316336001600160a01b03167f7d233b2ffded63eccd0879cd7afc44e74118b788331db4d67730c6037d142696858560405161110c9291909182521515602082015260400190565b60405180910390a38015611126576111248684610dbb565b505b50505050505050505050505050505050565b6000546001600160a01b031633146111625760405162461bcd60e51b81526004016104e890612dc8565b6001600160a01b0381166111c75760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201526564647265737360d01b60648201526084016104e8565b6111d0816113f2565b50565b6000546001600160a01b031633146111fd5760405162461bcd60e51b81526004016104e890612dc8565b61054c8282808060200260200160405190810160405280939291908181526020016000905b8282101561124e5761123f60408302860136819003810190612dfd565b81526020019060010190611222565b505050505061199f565b60006001600160a01b038316158015906112d7575082826040518163ffffffff1660e01b8152600401602060405180830381865afa15801561129e573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906112c291906133e4565b60e083901b6001600160e01b03199081169116145b90505b92915050565b60005b815181101561054c57600082828151811061130057611300612e3e565b6020026020010151600001519050600083838151811061132257611322612e3e565b602002602001015160200151905060006001600160a01b0316826001600160a01b0316148061135857506001600160a01b038116155b1561137657604051635d7aa74360e11b815260040160405180910390fd5b6001600160a01b0382811660008181526001602090815260409182902080546001600160a01b031916948616948517905581519283528201929092527f388056c710663a451dfea6adfe8ff11b52af5529b0a3d1c69ba90f1fc3f2dc56910160405180910390a1505080806113ea90613424565b9150506112e3565b600080546001600160a01b038381166001600160a01b0319831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b81511561145157815182602001fd5b8060405162461bcd60e51b81526004016104e8919061343d565b60005b815181101561054c576114d982828151811061148c5761148c612e3e565b6020026020010151600001518383815181106114aa576114aa612e3e565b6020026020010151602001518484815181106114c8576114c8612e3e565b602002602001015160400151610936565b60010161146e565b60006114fd8960078111156114f8576114f8612e93565b611ab1565b156115165761150f8888888686611ad5565b90506115b9565b61153089600781111561152b5761152b612e93565b611afb565b156115445761150f88888888888888611b1e565b61155989600781111561107257611072612e93565b156115745761156c338989898787611b65565b5060006115b9565b61158e89600781111561158957611589612e93565b611beb565b156115a05761150f8888888686611c0f565b60405163596de99760e01b815260040160405180910390fd5b98975050505050505050565b600060038260078111156115db576115db612e93565b14806112da575060075b8260078111156115f7576115f7612e93565b1492915050565b60008082600781111561161357611613612e93565b14806116305750600182600781111561162e5761162e612e93565b145b8061164c5750600282600781111561164a5761164a612e93565b145b806112da575060036115e5565b6000805b868110156119065785858281811061167757611677612e3e565b905060200201356000146118fe57600088888381811061169957611699612e3e565b90506020020160208101906116ae9190612a98565b6040516370a0823160e01b81523060048201526001600160a01b0391909116906370a0823190602401602060405180830381865afa1580156116f4573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906117189190613450565b90507f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031689898481811061175657611756612e3e565b905060200201602081019061176b9190612a98565b6001600160a01b03160361179357831561178457918201915b61178e8582611911565b6118fc565b831561185e577f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03166341976e098a8a858181106117da576117da612e3e565b90506020020160208101906117ef9190612a98565b6040516001600160e01b031960e084901b1681526001600160a01b039091166004820152602401602060405180830381865afa158015611833573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906118579190613450565b8102830192505b88888381811061187057611870612e3e565b90506020020160208101906118859190612a98565b60405163a9059cbb60e01b81526001600160a01b03878116600483015260248201849052919091169063a9059cbb906044016020604051808303816000875af11580156118d6573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906118fa9190612e54565b505b505b60010161165d565b509695505050505050565b604051632e1a7d4d60e01b8152600481018290527f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031690632e1a7d4d90602401600060405180830381600087803b15801561197357600080fd5b505af1158015611987573d6000803e3d6000fd5b5061054c925050506001600160a01b03831682611cb4565b60005b815181101561054c5760008282815181106119bf576119bf612e3e565b602002602001015160000151905060008383815181106119e1576119e1612e3e565b602002602001015160200151905060006001600160a01b0316826001600160a01b03161480611a1757506001600160a01b038116155b15611a355760405163acb22e5160e01b815260040160405180910390fd5b6001600160a01b0382811660008181526002602090815260409182902080546001600160a01b031916948616948517905581519283528201929092527f53db4a2342abba949712a6909b124e7452f4c84834894b2a75a377f5201ef610910160405180910390a150508080611aa990613424565b9150506119a2565b60006002826007811115611ac757611ac7612e93565b14806112da575060066115e5565b6000611ae5338787878787611b65565b611af185858585611dd2565b9695505050505050565b600080826007811115611b1057611b10612e93565b14806112da575060046115e5565b600080611b2d88888888611ee2565b90506000611b3d89898787611f42565b9050611b4d338b8b8b8989611b65565b611b578183613469565b9a9950505050505050505050565b60005b83811015611be257828282818110611b8257611b82612e3e565b90506020020135600014611bda57611bda8787878785818110611ba757611ba7612e3e565b9050602002016020810190611bbc9190612a98565b868686818110611bce57611bce612e3e565b90506020020135611fc3565b600101611b68565b50505050505050565b60006001826007811115611c0157611c01612e93565b14806112da575060056115e5565b6000611c1d85858585611f42565b50611c2c338787878787611b65565b6040516370a0823160e01b81523060048201527f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316906370a0823190602401602060405180830381865afa158015611c90573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611af19190613450565b80471015611d045760405162461bcd60e51b815260206004820152601d60248201527f416464726573733a20696e73756666696369656e742062616c616e636500000060448201526064016104e8565b6000826001600160a01b03168260405160006040518083038185875af1925050503d8060008114611d51576040519150601f19603f3d011682016040523d82523d6000602084013e611d56565b606091505b5050905080611dcd5760405162461bcd60e51b815260206004820152603a60248201527f416464726573733a20756e61626c6520746f2073656e642076616c75652c207260448201527f6563697069656e74206d6179206861766520726576657274656400000000000060648201526084016104e8565b505050565b6000805b84811015611ed957838382818110611df057611df0612e3e565b90506020020135600014611ed1576000868683818110611e1257611e12612e3e565b9050602002016020810190611e279190612a98565b6040516370a0823160e01b81523060048201526001600160a01b0391909116906370a0823190602401602060405180830381865afa158015611e6d573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611e919190613450565b9050611ec3878784818110611ea857611ea8612e3e565b9050602002016020810190611ebd9190612a98565b826121d7565b611ecd9084613480565b9250505b600101611dd6565b50949350505050565b6000805b84811015611ed957611f36868683818110611f0357611f03612e3e565b9050602002016020810190611f189190612a98565b858584818110611f2a57611f2a612e3e565b905060200201356121d7565b90910190600101611ee6565b6000805b84811015611ed957838382818110611f6057611f60612e3e565b90506020020135600014611fbb57611fb6868683818110611f8357611f83612e3e565b9050602002016020810190611f989190612a98565b858584818110611faa57611faa612e3e565b905060200201356124c1565b820191505b600101611f46565b6040516001600160a01b0385811660248301526044820183905283169060640160408051601f198184030181529181526020820180516001600160e01b031663095ea7b360e01b17905251612018919061328d565b6000604051808303816000865af19150503d8060008114612055576040519150601f19603f3d011682016040523d82523d6000602084013e61205a565b606091505b505060405163976ce49560e01b81526001600160a01b0384811660048301528581166024830152604482018490528616915063976ce4959060640160408051808303816000875af11580156120b3573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906120d79190613498565b505060405163bf27304160e01b81526001600160a01b03838116600483015285169063bf2730419060240160c060405180830381865afa15801561211f573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061214391906134bc565b60409081015190516370a0823160e01b81526001600160a01b038581166004830152909116906370a0823190602401602060405180830381865afa15801561218f573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906121b39190613450565b156121d157604051639e703a0560e01b815260040160405180910390fd5b50505050565b60007f00000000000000000000000000000000000000000000000000000000000000008215806122185750806001600160a01b0316846001600160a01b0316145b1561222657829150506112da565b6001600160a01b038085166000908152600260205260409020541680156122f6576040516001600160a01b0386166024820152604481018590526000906122c390839060640160408051601f19818403018152918152602080830180516001600160e01b03166321ebbf0160e01b179052815180830190925260138252721d1bddd85c991cd3985d1a5d9951985a5b1959606a1b9082015261281c565b9050600080828060200190518101906122dc9190613550565b915091506122ea82826121d7565b955050505050506112da565b600080612302876128a0565b91509150866001600160a01b0316816001600160a01b031663db36eb2e6040518163ffffffff1660e01b8152600401602060405180830381865afa15801561234e573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906123729190612e76565b6040516001600160a01b0390911660248201526044810188905260640160408051601f198184030181529181526020820180516001600160e01b031663095ea7b360e01b179052516123c4919061328d565b6000604051808303816000865af19150503d8060008114612401576040519150601f19603f3d011682016040523d82523d6000602084013e612406565b606091505b50506040516001600160a01b03808a16602483018190528188166044840152606483018a9052908516608483015260a48201526000915060c40160408051601f19818403018152918152602080830180516001600160e01b0316639cffaf6f60e01b1790528151808301909252600c82526b39bbb0b820b6b7bab73a24b760a11b9082015290915060009061249e908490849061281c565b9050808060200190518101906124b49190613450565b9998505050505050505050565b60007f00000000000000000000000000000000000000000000000000000000000000008215806125025750836001600160a01b0316816001600160a01b0316145b1561251057829150506112da565b6001600160a01b03808516600090815260026020526040902054168015612607576040516001600160a01b0386166024820152604481018590526000906125ac90839060640160408051601f19818403018152918152602080830180516001600160e01b03166337523bed60e11b179052815180830190925260128252711d1bddd85c991cd05cdcd95d11985a5b195960721b9082015261281c565b9050600080828060200190518101906125c59190613550565b91509150876001600160a01b0316826001600160a01b0316146125fb5760405163245feacb60e01b815260040160405180910390fd5b94506112da9350505050565b600080612613876128a0565b915091506000816001600160a01b031663db36eb2e6040518163ffffffff1660e01b8152600401602060405180830381865afa158015612657573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061267b9190612e76565b60405163095ea7b360e01b81526001600160a01b03808316600483015260001960248301529192509086169063095ea7b3906044016020604051808303816000875af11580156126cf573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906126f39190612e54565b506040516001600160a01b038087166024830152808a1660448301819052606483018a9052908516608483015260a482015260009060c40160408051601f19818403018152918152602080830180516001600160e01b03166305a319ad60e21b1790528151808301909252601382527214ddd85c105b5bdd5b9d13dd5d11985a5b1959606a1b90820152909150600090612790908590849061281c565b60405163095ea7b360e01b81526001600160a01b038581166004830152600060248301529192509088169063095ea7b3906044016020604051808303816000875af11580156127e3573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906128079190612e54565b5080806020019051810190611b579190613450565b60606000846001600160a01b031684604051612838919061328d565b600060405180830381855af49150503d8060008114612873576040519150601f19603f3d011682016040523d82523d6000602084013e612878565b606091505b509250905080158061288957508151155b15612898576128988284611442565b509392505050565b60008060006128ae84610adf565b905060006128bb826128c7565b91959194509092505050565b6001600160a01b03808216600090815260016020526040812054909116806112da57604051636ce6ae9b60e11b815260040160405180910390fd5b60008083601f84011261291457600080fd5b5081356001600160401b0381111561292b57600080fd5b6020830191508360208260061b850101111561294657600080fd5b9250929050565b6000806020838503121561296057600080fd5b82356001600160401b0381111561297657600080fd5b61298285828601612902565b90969095509350505050565b60008083601f8401126129a057600080fd5b5081356001600160401b038111156129b757600080fd5b6020830191508360208260051b850101111561294657600080fd5b600080600080604085870312156129e857600080fd5b84356001600160401b03808211156129ff57600080fd5b612a0b8883890161298e565b90965094506020870135915080821115612a2457600080fd5b50612a318782880161298e565b95989497509550505050565b6020808252825182820181905260009190848201906040850190845b81811015612a77578351151583529284019291840191600101612a59565b50909695505050505050565b6001600160a01b03811681146111d057600080fd5b600060208284031215612aaa57600080fd5b8135612ab581612a83565b9392505050565b803560088110610c8357600080fd5b600080600080600060808688031215612ae357600080fd5b8535612aee81612a83565b94506020860135612afe81612a83565b9350612b0c60408701612abc565b925060608601356001600160401b03811115612b2757600080fd5b612b338882890161298e565b969995985093965092949392505050565b634e487b7160e01b600052604160045260246000fd5b604080519081016001600160401b0381118282101715612b7c57612b7c612b44565b60405290565b604051606081016001600160401b0381118282101715612b7c57612b7c612b44565b604051601f8201601f191681016001600160401b0381118282101715612bcc57612bcc612b44565b604052919050565b600082601f830112612be557600080fd5b81356001600160401b03811115612bfe57612bfe612b44565b612c11601f8201601f1916602001612ba4565b818152846020838601011115612c2657600080fd5b816020850160208301376000918101602001919091529392505050565b600080600060608486031215612c5857600080fd5b8335612c6381612a83565b92506020840135612c7381612a83565b915060408401356001600160401b03811115612c8e57600080fd5b612c9a86828701612bd4565b9150509250925092565b60008060408385031215612cb757600080fd5b50508035926020909101359150565b600080600080600080600080600060a08a8c031215612ce457600080fd5b8935612cef81612a83565b985060208a01356001600160401b0380821115612d0b57600080fd5b612d178d838e0161298e565b909a50985060408c0135915080821115612d3057600080fd5b612d3c8d838e0161298e565b909850965060608c0135915080821115612d5557600080fd5b612d618d838e0161298e565b909650945060808c0135915080821115612d7a57600080fd5b818c0191508c601f830112612d8e57600080fd5b813581811115612d9d57600080fd5b8d6020828501011115612daf57600080fd5b6020830194508093505050509295985092959850929598565b6020808252818101527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572604082015260600190565b600060408284031215612e0f57600080fd5b612e17612b5a565b8235612e2281612a83565b81526020830135612e3281612a83565b60208201529392505050565b634e487b7160e01b600052603260045260246000fd5b600060208284031215612e6657600080fd5b81518015158114612ab557600080fd5b600060208284031215612e8857600080fd5b8151612ab581612a83565b634e487b7160e01b600052602160045260246000fd5b81835281816020850137506000828201602090810191909152601f909101601f19169091010190565b6001600160a01b03868116825260208083018790526000916080840191604060088910612f0f57634e487b7160e01b600052602160045260246000fd5b888187015260606080818801528488865260a08801905060a08960051b89010195508960005b8a811015612fe657898803609f190183528135368d9003605e19018112612f5b57600080fd5b8c018035612f6881612a83565b8816895280870135612f7981612a83565b8816898801528086013536829003601e19018112612f9657600080fd5b810180356001600160401b03811115612fae57600080fd5b803603831315612fbd57600080fd5b86888c0152612fd1878c01828b8501612ea9565b9a505050928601925090850190600101612f35565b50959d9c50505050505050505050505050565b60005b83811015613014578181015183820152602001612ffc565b838111156121d15750506000910152565b6000815180845261303d816020860160208601612ff9565b601f01601f19169290920160200192915050565b604080825283519082018190526000906020906060840190828701845b828110156130935781516001600160a01b03168452928401929084019060010161306e565b50505083810382850152611af18186613025565b60006001600160401b038211156130c0576130c0612b44565b5060051b60200190565b600082601f8301126130db57600080fd5b815160206130f06130eb836130a7565b612ba4565b828152600592831b850182019282820191908785111561310f57600080fd5b8387015b858110156131a25780516001600160401b038111156131325760008081fd5b8801603f81018a136131445760008081fd5b8581015160406131566130eb836130a7565b82815291851b8301810191888101908d8411156131735760008081fd5b938201935b8385101561319157845182529389019390890190613178565b885250505093850193508401613113565b5090979650505050505050565b6000806000606084860312156131c457600080fd5b83516001600160401b03808211156131db57600080fd5b818601915086601f8301126131ef57600080fd5b815160206131ff6130eb836130a7565b82815260059290921b8401810191818101908a84111561321e57600080fd5b948201945b8386101561324557855161323681612a83565b82529482019490820190613223565b9189015191975090935050508082111561325e57600080fd5b61326a878388016130ca565b9350604086015191508082111561328057600080fd5b50612c9a868287016130ca565b6000825161329f818460208701612ff9565b9190910192915050565b600080600080608085870312156132bf57600080fd5b6132c98535612a83565b84359350602085013592506132e060408601612abc565b915060608501356001600160401b03808211156132fc57600080fd5b818701915087601f83011261331057600080fd5b813561331e6130eb826130a7565b8082825260208201915060208360051b86010192508a83111561334057600080fd5b602085015b838110156133d457848135111561335b57600080fd5b803586016060818e03601f1901121561337357600080fd5b61337b612b82565b602082013561338981612a83565b8152604082013561339981612a83565b60208201526060820135878111156133b057600080fd5b6133bf8f602083860101612bd4565b60408301525084525060209283019201613345565b50979a9699509497505050505050565b6000602082840312156133f657600080fd5b81516001600160e01b031981168114612ab557600080fd5b634e487b7160e01b600052601160045260246000fd5b6000600182016134365761343661340e565b5060010190565b6020815260006112d76020830184613025565b60006020828403121561346257600080fd5b5051919050565b60008282101561347b5761347b61340e565b500390565b600082198211156134935761349361340e565b500190565b600080604083850312156134ab57600080fd5b505080516020909101519092909150565b600060c082840312156134ce57600080fd5b60405160c081018181106001600160401b03821117156134f0576134f0612b44565b60405282516134fe81612a83565b8152602083015161350e81612a83565b6020820152604083015161352181612a83565b80604083015250606083015160608201526080830151608082015260a083015160a08201528091505092915050565b6000806040838503121561356357600080fd5b825161356e81612a83565b602093909301519294929350505056fea26469706673582212201f0e0cf11a8e1c32ed117283a4ad1033831864105fc30bce35e900c6afe5f44f64736f6c634300080d0033";

type LiquidationHelperConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: LiquidationHelperConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class LiquidationHelper__factory extends ContractFactory {
  constructor(...args: LiquidationHelperConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "LiquidationHelper";
  }

  deploy(
    _repository: string,
    _chainlinkPriceProvider: string,
    _lens: string,
    _exchangeProxy: string,
    _magicians: LiquidationHelper.MagicianConfigStruct[],
    _swappers: LiquidationHelper.SwapperConfigStruct[],
    _baseCost: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<LiquidationHelper> {
    return super.deploy(
      _repository,
      _chainlinkPriceProvider,
      _lens,
      _exchangeProxy,
      _magicians,
      _swappers,
      _baseCost,
      overrides || {}
    ) as Promise<LiquidationHelper>;
  }
  getDeployTransaction(
    _repository: string,
    _chainlinkPriceProvider: string,
    _lens: string,
    _exchangeProxy: string,
    _magicians: LiquidationHelper.MagicianConfigStruct[],
    _swappers: LiquidationHelper.SwapperConfigStruct[],
    _baseCost: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _repository,
      _chainlinkPriceProvider,
      _lens,
      _exchangeProxy,
      _magicians,
      _swappers,
      _baseCost,
      overrides || {}
    );
  }
  attach(address: string): LiquidationHelper {
    return super.attach(address) as LiquidationHelper;
  }
  connect(signer: Signer): LiquidationHelper__factory {
    return super.connect(signer) as LiquidationHelper__factory;
  }
  static readonly contractName: "LiquidationHelper";
  public readonly contractName: "LiquidationHelper";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): LiquidationHelperInterface {
    return new utils.Interface(_abi) as LiquidationHelperInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): LiquidationHelper {
    return new Contract(address, _abi, signerOrProvider) as LiquidationHelper;
  }
}
